module.exports = __webpack_public_path__ + "static/img/建筑智能化_中央空调系统2@2x.6f1290a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/buliding/建筑智能化_中央空调系统2@2x.png
// module id = 0H/B
// module chunks = 1